import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'; 
import { AuthenticationService } from '../authentication.service';
import { MatSnackBar } from '@angular/material';

 
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, protected snackBar?: MatSnackBar) {}
 
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.msgNotification();
                this.authenticationService.logout();
                //location.reload(true);
            }

            if (err.status === 406) {
                // auto logout if 401 response returned from api
                console.log("Error of 406, as wrong session is requested");
                this.msgNotification();
                this.authenticationService.logout();
                //location.reload(true);
            }

            if (err.status === 410) {
                // auto logout if 401 response returned from api
                console.log("Error of 410, as wrong session is requested");
                this.msgNotification();
                this.authenticationService.logout();
                //location.reload(true);
            }

            let error = '';
            if(err.error){
                error = err.error.message || err.statusText;
            }
            return throwError(error);
        }))
    }

    msgNotification(){
        this.snackBar.open("Session Expired!", "Clear", {
            duration: 2000,
        });
    }
}